import { useGetAppointments } from "@/features/appointments/hooks/useGetAppointments"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import { useBloodTest } from "@/features/holifya-tests/blood-test/hooks/useBloodTest"
import { useDnaTest } from "@/features/holifya-tests/dna-test/hooks/useDnaTest"
import { useMembership } from "@/features/membership/hooks/useMembership"
import { SubType } from "@/features/membership/types/SubType"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { saveEvent } from "../../../utils/apis/user-service"
import { useUserStore } from "../../../utils/stores/useUserStore"
import { useCompletionPercentage } from "../../metabolic-health/hooks/useMetabolicHealth"
import { usePercentageRing } from "../hooks/usePercentageRing"
import ControlPanelWidgetSingleElement from "./controlPanelWidget/ControlPanelWidgetSingleElement"

const ControlPanelWidget = () => {
    const { sendEvent } = useCreateEvent()
    const navigate = useNavigate()
    const { fullPercentage } = useCompletionPercentage();
    const { getTotalDnaPercentage, getTotalBloodPercentage, getTotalClinicalHistoryPercentage, isPercentageRingVisible } = usePercentageRing()
    const { userData } = useUserStore()
    const email = userData.email
    const membership = useMembership()
    const { refetch: refetchAppointments} = useGetAppointments()

    const onShowMoreClick = async () => {
        navigate("/control-panel-page")
        if (!email) return
        saveEvent(
            email,
            "show_more_control_panel_button_clicked",
            () => { },
            () => { },
            "control_panel_widget",
        )
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "open_control_panel" }
        })
    }

    useEffect(() => {
        void sendEvent({
            event: EventType.WIDGET_VIEW,
            sub_category: "control_panel_widget",
        })
    }, [])

    const { dnaTestUser } = useDnaTest()
    const { bloodTestUser } = useBloodTest()

    const totalPercentage = dnaTestUser ?
        getTotalDnaPercentage().percentage :
        membership === SubType.HEALTH ?
        ((getTotalBloodPercentage().percentage*getTotalBloodPercentage().numberOfItems + getTotalClinicalHistoryPercentage().percentage*getTotalClinicalHistoryPercentage().numberOfItems)/ (getTotalClinicalHistoryPercentage().numberOfItems + getTotalBloodPercentage().numberOfItems)) : 0

    useEffect(() => {
        refetchAppointments()
    }, [])
    
    return (
        <div className="w-full space-y-md rounded-xl border border-solid border-border px-2.5 pb-2.5 pt-3.5 shadow-platform-new max-w-[800px]">
            <div className="w-full flex items-center justify-between font-bold text-xs">
                <div className="flex items-center">
                    <div className="mr-5 md:text-sm">Health Hub</div>
                    {/* {isPercentageRingVisible && <PercentageRing percentage={totalPercentage} />} */}
                </div>
                <div
                    className="text-primary cursor-pointer"
                    onClick={onShowMoreClick}
                >
                    Mostra di più
                </div>
            </div>
            <ControlPanelWidgetSingleElement navigate={navigate} />
        </div>
    )
}

export default ControlPanelWidget
